/** "5s ago" / "3m ago" / "2h ago" / "4d ago"; null for empty/unparseable input. */
export function relativeSince(ts) {
  if (!ts) return null;
  const t = typeof ts === 'string' ? Date.parse(ts) : new Date(ts).getTime();
  if (Number.isNaN(t)) return null;
  const sec = Math.max(0, Math.floor((Date.now() - t) / 1000));
  if (sec < 60)    return `${sec}s ago`;
  if (sec < 3600)  return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  return `${Math.floor(sec / 86400)}d ago`;
}
